import { render, staticRenderFns } from "./WelcomeStep3Page.vue?vue&type=template&id=fc7598d4&scoped=true"
import script from "./WelcomeStep3Page.vue?vue&type=script&lang=ts"
export * from "./WelcomeStep3Page.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeStep3Page.vue?vue&type=style&index=0&id=fc7598d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7598d4",
  null
  
)

export default component.exports